import React, { useState } from 'react';
import httpClient from '../../../services/httpClient'
import { Address } from "../../form"

const Match = ({ lawFirm, accountNumber, sortCode, match, pdfLink, userName, loggedInLawFirmName }) => {

    const [error, setError] = useState('');

    const statusContainerOutput = {
        backgroundColor: '#f4f4f4',
        borderRadius: 5.7,
    }

    const statusContainer = {
        borderRadius: 5.7,
        backgroundColor: '#f4f4f4',
        borderBottomColor: '#2ed9c3',
        borderBottomStyle: 'solid',
        borderBottomWidth: 10
    }

    const statusContainerMainHeader = {
        fontSize: 42,
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: 'black'
    }

    const statusContainerSubHeader = {
        fontSize: 18,
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: 'black'
    }

    const accountDetailsText = {
        fontSize: '16px',
        fontWeight: '300',
        fontStretch: 'normal',
        fontStyle: 'normal',
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#000'
    }

    const handleDownloadPdfCopy = async (event) => {
        let response = null;
        try {
            httpClient.defaults.headers.common['Username'] = userName;
            httpClient.defaults.headers.common["Account-Number"] = accountNumber;
            httpClient.defaults.headers.common["Sort-Code"] = sortCode;
            httpClient.defaults.headers.common["Users-Law-Firm"] = loggedInLawFirmName;
            httpClient.defaults.headers.common["Users-Law-Firm-Reference"] = "";
            response = await httpClient.get(pdfLink, { responseType: 'blob' });
            const url = window.URL.createObjectURL(response, { type: 'application/pdf' });
            let a = document.createElement('a');
            a.href = url;
            a.download = "outcome.pdf";
            a.click();
            a.remove();
        } catch (e) {
            if (e.response.status === 404) {
                //404 status code means transient Id from the original search has expired. We want to display a specific message for this error scenario
                setError('Your Session has timed out. You will need to start a new search');
            }
            else {
                setError('Unfortunately we were unable to retrieve your PDF Summary at this time. If you require further assistance, please contact the team on 0343 221 0610');
                if (!e.response.data) {
                    if (e.response.data.errors?.length >= 1) {
                        setError(e.response.data.errors[0]);
                    }
                }
            }
        }
    }

    return (
        <div data-testid="match-component">
            {match === 'Match' ? (
                <div data-testid="match-component-matched">
                    <div style={statusContainer} className="mt-2 p-5">
                        <div className="row">
                            <div className="col-1">
                                <img height="75px" src="data:image/png;base64, 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" alt="confirmly Matched Icon" />
                            </div>
                            <div className="col-9">
                                <span style={statusContainerMainHeader} className="ml-3" id="itsStatus">
                                    It's a match
                                </span>
                                <p style={statusContainerSubHeader} className="mt-1 ml-3" id="itsUnderReview">
                                    The law firm is known and is not under review.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div style={accountDetailsText} className="row mt-3 mb-3">
                        <div className="col-10 text-danger">
                            {error}
                        </div>
                    </div>
                    <div style={accountDetailsText} className="row">
                        <div className="col-10">
                            The account details you provided match the ones we hold for the firm.
                        </div>
                        <div className="col-2">
                            <button className="fs-6 btn btn-dark" onClick={handleDownloadPdfCopy} id="pdfButton"> <i className="fa-solid fa-file-arrow-down"></i>&nbsp;&nbsp;&nbsp;DOWNLOAD PDF </button>
                        </div>
                    </div>
                    <div style={accountDetailsText} className="row mb-5">
                        <div className="col-12">
                            For a full summary download the pdf.
                        </div>
                    </div>
                    {
                        /* 
                            JAS-7677 - COMMENTED UNTIL: JAS-7601
                            <div style={accountDetailsText} className="row mt-4 mb-5">
                                <div className="col-12 fw_bold text-decoration-underline">
                                    Does this mean it's safe to send the money?
                                </div>
                            </div> 
                        */
                    }

                    <div style={statusContainerOutput} className="p-5">
                        <div className="row">
                            <div className="col-1">
                                <img src="data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAYAAAAcaxDBAAAACXBIWXMAAAsTAAALEwEAmpwYAAAM7ElEQVR4nO2de5AUxR3HP3u85CVRQMWIXJnAROMY0KoUZTkRFcVHoomVKolAQnwkxUUEyldVfIAx5oFSoChIiUIiKJQGE0yiKKbQUYMaH7FT6ohEnvIKjwO5A87byR+/X9/uLbt7s7Ozd0Ddt+pqrmd7+tf93e7pX//6179NhWFIO5JDR4BUKtWmlXADfxAwGHCBgUA1cDzQF+iek30vsA3YAqwBVgEGeN843ietUuECCMOQVBiGrU6oG/j9gEv071yEuCSwDXgFeB543jjepoTKjYRWJdQN/O7ASGAUMAzIFloPvAd8AHyE9LzPEYJqc4rqhXwBJyI9+VTgDGAI0DUrXwisABYCi4zj7U2uNfnRKoS6gV8NTAJ+CvTM+mgl0pNeBN4xjtdQppxOwFnARUjPH5r18R5gHjDdON6acuQUQ0UJVSKnAKOBDnr7E2AusNg43rrEhTaXfzJwFXAdMEhvNwILgCmVILYihLqB3xO4A5gIdNbby4D7gZeN47WqWuEGfgq4ALgZGKG3DwAzgF8bx9uTlKzECXUD/3vALOAkvbUcuNM43spEBJQJN/CHAvcAw/XWBqDGON5zSZSfGKFu4PcAZgJj9dZqYIJxvL+VV8XKwA38y4AHgK/prfnAeON4X5RTbiKEuoF/OrAE0R/TwDRgsnG8+nIqV2m4gd8VuBu4CahC9NkrjeP9J26ZZRPqBv4PgCcQ5Xs9MMo4nh+3Qm0BN/A9RLXqjywaxhjHezZOWWEYUlVGRSYCzyBkLgeGHG5kAmidhyBt6A48o22LhViEuoF/FzBdn58NXGwcb3vcSrQ1tO4XI22pAqZrG0tGyUNeBd2tyduN4/0mjuBDFW7g/xK4V5OTjeP9KuqzJb9DdShM1+StxvHuK6WyhwvcwL8FmKrJScbxZkR5riRCdQJ6BhkSR1zPzEVWT00DP4wyUUUmVFWjlchLe7ZxvJoE6nzIww38WcA4ZPYf2pJKFWmWV6V9CZnZfHwCdY0MN/A7uIE/wQ38b7emXMV4MrP/EuWiKKLM8jMRpX09MNI4XmNZVSwdQ5F19wOtLBdt60ik7QMRLoqiKKG6Nh+LvEdGtZFq1EmvXYvmqhC0zaMQDsYqJwVRkFC1Gs3S5LTDUWlPCtr2aZqcpdzkRbEeegdiNVoNTE6ueoctJiNcnIRwkxd5CVXj8ERNTjjUDR2tAeVggiYnKkcHoVAPnYIYh5cfqia4toBysRzhZkq+PAcRqsyP1uSdFarb4QzLyeh8vTRfD52E7AEtO1Qs7YcSlJNlCEeTcj9vtlLSrd5NyO7khcbxlidVETfwTyKz9VAKvgHchuiCcSxAa4zjrYjxXEG4gT8ceAnZTe1nt6jDMBTPkSyMRMj8BHg5yUogprHvlvF8f2QruFSk3cA/OuF9+ZcRjgYhnD1mP8gldJRe51Zgd9Lqbm8ho6A1cAXyWuvUUsZSYBwvdAN/LmKRGkU+QtU9ZpgmFydZgRz81jjenytYfhPcwK/klvVihNBhbuD3s24/2ZPSJYh7zMpKOyEcCVCOViKcXWLv5xIK4h7TjmiwXOUl9Fy9vlgh4f30ekyFym+GHFNbdYXEWK4sd0Ko+mf2Rbzg3klaqhv455HxL7om6fIL4MdZ/1fKIP4Owllf5bCphw7W63vlesEVwI1Z/5/jBv6QCshogvozZRvCR7uBf2zScpSr9zQ5GDKEunr9IGmhujy7HNiPuLwA3JC0nBxciCwI1iLvua6IO2UlYDlzIUPoQL1+VAGBNSrnKWT7OQ1c7QZ+7wrIsrC9cxZi7Qe4wQ382I4dRWA5GwgZQqv1uiZJSeo/dK0mH1SfzKXAUcD1ScrKknkKcBnybpuLLBE/RtpY1NoeE2v0Wg0ZQo/X6+cJC7saOBZ4zTiefdc8qNcaN/BzV2pJ4BeIbrjAON4OXfE9rJ/dWPix2LCcHQ8ZQu2hgW0JC7MNyN7cWgF8iKzNr0hSmBp3rBaRLfMPiCHjfDfwv5mkTDKc9YUMofboSu4BgdhwA/9c5DDBRmQbGpB1MJnGJt1jxgBfAVYYxzNZMq2PPSS/DW456w4xncUiwpI1xzjelzmfPQHsAr7jBr5LAshRlfJt9z6EnAwZ7QZ+ryRk5kNFCNUDA1cgvuxzcj9XU9rjmkyqx5wPnIbYTZfmkbkKeAHpSRVbXFSqh45DLNqLjONtLZAnu8ckoXTbETErz4iwsBNipVSoJkKt8bXsoeAG/lHIURbINOAgGMf7DHgOUbqvK5QvosxqxHi9D3i0SNZliOu3Va2SgOVsL2QIbTZTlYkfAX2AfxrHa8kuYNWZGjfwOxTNWRx28fBkMe+WHBUqqVdNMw3JErpFrycmIMAOvYK9MwtW6R6ALE9Lhhv43YgwIrIwD/gCuNAN/FPjyMyB5WwLZAhdo9fqckrWAwCDgc3An1rKn6NCxV3fj0ZMgq8ax/t3BJm7ydgUkrBCVet1DWQIXaXXcr8xO4weKcFq9UdgN/GVbivzoRKesXnHuoF/dAyZ2bCcrYIMoVYJPiNuqbpNfCXQADwS9Tk9bBVLhVI76+nI4iHyURjjeAEyQfWgfCuU5cxAhtD39TpET/XGwc8RVWmxcbwtLWXOgVWhxriBX4pF374miqlKhVC2CqVcWdvu+6CEaiSEbYgKc1aMgrsghEIEp9RcGMdbjdgtuxFR6c5aPOynuKpUCC8A/wW+jhypiYOzEM622WgS2d/MK3q9KEbBIxH14U3jeG/FrFzT5BSxx9QgI+Ip43glG3WM46XJvEvj2hQsV5a7ZoQetINXAvJZlUrFMsQbo5oWPEzUzmrtqVFUpUJ4HFHIL3IDf2BLmfPgoJ3iJt8mdXTYiNgSB0Tdm3cD/2zgdU3uQSzycdEN8fJ4yThewZHiBv61iPEYyreQ9UQ61oPG8Sa0lDmrDicjWywh8FXjeJuanQJRz4cVmryqhAplD5eeyFIs7p+dEFtSurNlliOvFzpKU3BNMVfvPLAcrcgOFpNrMV8InAdc5wb+/RH9m7oCjO8zgLO7lb/lPunzj8LNX+5PkYkGcRBS0C0EfneCw4DO5Z1l2B+muX6DCRvCsAvS21qEmgrt6mxh9me5L/9FyLAdhISViIKXAN6s2xUxe2Gsb9iHkrmNIjuwoToYrExA5rv1u2kIwxRie4gagOAChKM9CGdNaEao2imtZfvmiIU/DTS8XVfLhoZ9ER/JjyW1m+2/T7YwOhYCvPjF/6hLxz82FQJ/2d2kMj9ZwqOWm3m5bpL51JPpSPSYERqjoyhUiZ8TAo9sX0djzNBvb9fV2h5XDxQ9lGsc7w3gH3XpRh7bsSGWPIClu7ew9kA9yOQyP8ozyskIhKPpuZ8fRKhu9S7Q5D0R63ZnCjauPlDH7B3rSEd7FTXh0wN1zNq+1moHtxvH2xjhsZoU1L9RtzO7Z0fG63t3snjXJlvRGuN4+yM+ajlZkC9UUbFTIAeA4RrwpCiM4+0K4ftA3et7dzJ162fsaoxmG3l17w7u3fJpuC9MVyHvoxlRnjOOF4Tiv5R+unYzc3asY1/YssaWJuTZ2i08vH0toaiIdxnH+3sUmcrFcISbKfnyFDyN7Ab+74FbkcNObpSzSqqTLgV6d63qEI7o0Sd1Xo/eHNex+YTdEKb5YN8e/rp7Kx/vb3oFzQd+VqpvlRv4I/XZLsd26MSlRx/HOd2OoVeH5gpMXbqRf9XX8tzurdnv+ruM40UahbqYMEgknanG8W7LzVP0eLfqZB8iJ8fuM453a0TB/RFr06X2Xp+OnenboTNdqqqobfwyXNdQHzaGodX/doZws3G8xwuVGUHmtxC37CY7xAkdu9C3Y2dSwM7GhvSGhn0p7ZGkYF0oX96yEmRMBW5BYj2dli+AVovn5fWg6FJk9TOslPOeamy+HjE85G6tpBFf+yXAo8bxdkUtt4i8FGIs+Qmi1uQq6fuB1xAfqyeM4x0ooWwPWfRUAZcXCpwVKQCBG/jzkBPJ65HINyWdSNaGnoK4qnQDtgJrjeMl5lSRR2ZHZGgehywQNiHHa+pilNUbcVnsD8w3jlfQfhqV0B7Au4h32XIkAk5rn5lvE+jG4QvIRLQKOLOY8h8pooMWcCVilRlOeRalww0zkTbvRaKOtbiSimSp1lgbY5B33zgNcHJEQ9s4DmnzmKgh3CKb/jUqzE2avFdD8RyR0LbZ2E03lRK6raS9FI1fZIMRTD0Se6q2ycZsmhw1ZpNFrGCCOdHFZiOhIg/riUonoJnIMIcSo4pBmdEZNcrYNKSXL0ci5hyW8e9UNVqETEBpZJjPKLWc9nCXJB/usj0ga8IBWcv2kdQKnIkYKKqQ9a6JYqVqK2jdDFLXKqTuZ5ZDpkV7UOtDMah1Ntz2sOvtPwyQFNp/uiJhtP+4SsJo//mfhNFmhObCPdJ+oKodyeH/rlKFpX/2R5UAAAAASUVORK5CYII=" alt="confirmly Matched Icon" />
                            </div>
                            <div className="col-9 mt-4">
                                <span className="fs-2">YOU ASKED US TO CHECK THESE DETAILS</span>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-11 fw-bold mt-2">
                                Company name
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 mt-2">
                                {lawFirm?.companyName}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 fw-bold mt-2">
                                Address
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 mt-2">
                                <Address lawFirm={lawFirm} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 fw-bold mt-2">
                                Regulation Registration Number for LMS Main Office
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 mt-2">
                                {lawFirm?.regulationRegistrationNumber ? (lawFirm?.regulationRegistrationNumber) : ('Not Supplied')}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 fw-bold mt-2">
                                Sort code
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 mt-2">
                                {sortCode}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 fw-bold mt-2">
                                Account number
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 mt-2">
                                {accountNumber}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (null)}
        </div>
    );
}

export default Match;